import React from 'react';
import ReactQuill from 'react-quill';
import { EditorContainer, ContentSection, EditorHeading, PreviewSection } from './style';

const Editor = {
  modules: {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { font: [] }],
      [{ size: [] }],
      ['bold', 'italic', 'underline'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['code-block'],
      ['link'],
      ['clean'],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  },
  formats: ['header', 'font', 'size', 'bold', 'italic', 'underline', 'list', 'bullet', 'link', 'align', 'code-block'],
};

export const TextEditor = React.memo(({ value, handleTextChange }) => {
  return (
    <EditorContainer>
      <ContentSection>
        <EditorHeading>Content</EditorHeading>
        <ReactQuill
          value={value}
          onChange={(updatedValue) => handleTextChange(updatedValue)}
          modules={Editor.modules}
          formats={Editor.formats}
          theme="snow"
          preserveWhitespace={true}
        />
      </ContentSection>
      <ContentSection>
        <EditorHeading>Preview</EditorHeading>
        <PreviewSection dangerouslySetInnerHTML={{ __html: value }}></PreviewSection>
      </ContentSection>
    </EditorContainer>
  );
});
